export default {"src":"/_next/static/media/redact-back-arrow.4403151e.svg","height":10,"width":7,"blurWidth":0,"blurHeight":0};